import Contact from "../models/Contact";
import CustomerContact from "../models/CustomerContact";
import Location from "../models/Location";
import User from "../models/User";

export default class CustomerContactRepository {

  static updateOrCreateContact(customer, contact, user, location) {

    let customer_id = customer.id || null;
    let contact_id = contact.id || null;

    return CustomerContact.api().fetch({customer: customer_id, contact: contact_id?contact_id:9999999999}).then(ccr => {

        let customer_contact_id = ccr.entities && ccr.entities.customer_contacts ? ccr.entities.customer_contacts[0].id : null;
        let customer_contact = customer_contact_id ? CustomerContact.query().with(['contact','location','user']).find(customer_contact_id) : null;
        let user_id = customer_contact && customer_contact.user && customer_contact.user.id ? customer_contact.user.id : null;
        let location_id = customer_contact && customer_contact.location && customer_contact.location.id ? customer_contact.location.id : null;

        let contact_p = null;
        if(contact) {
          contact_p = {
            full_name: [contact.first_name, contact.last_name].filter(i=>!!i).join(' '), 
            first_name: contact.first_name || null, 
            last_name: contact.last_name || null, 
            type: contact.type || null, 
            phone: contact.phone || null, 
            email: contact.email || null
          };
          contact_p.full_name = [contact_p.first_name, contact_p.last_name].join(' ');
        }

        let location_p = null;
        if(location) {
          location_p = {
            name: location.name || null, 
            street_address: location.street_address || null, 
            city: location.city || null, 
            region: location.region || null, 
            country: location.country || null, 
            postal: location.postal || null
          };
          location_p.address = Object.keys(location_p).filter(k=>k!=='name').map(k=>location_p[k]).filter(x=>x).join(', ');
        }

        let user_p = null;
        if(user) {
          user_p = {notification_preference: user.notification_preference};
          user_p.name = contact.full_name;
          if(contact && contact.email) {
            user_p.email = contact.email;
          }
        }

        return Promise.all([
          (contact_id ? Contact.api().update(contact_id, contact_p) : Contact.api().create(contact_p)),
          (location_id && location_p ? Location.api().update(location_id, location_p) : (location_p ? Location.api().create(location_p) : (new Promise(resolve => {return resolve()})))),
          (user_id && user_p ? User.api().update(user_id, user_p) : (new Promise(resolve => {return resolve()})))
        ]).then((results) => {

          contact_id = results[0].entities && results[0].entities.contacts ? results[0].entities.contacts[0].id : contact_id;
          contact = contact_id ? Contact.find(contact_id) : contact;
          location_id = results[1] && results[1].entities && results[1].entities.locations ? results[1].entities.locations[0].id : location_id;
          location = location_id ? Location.find(location_id) : location;

          return (customer_contact_id ? 
            CustomerContact.api().update(customer_contact_id, {customer_id, contact_id, location_id}) : 
            CustomerContact.api().create({customer_id, contact_id, location_id})).then((ccr2) => {

              customer_contact_id = ccr2.entities && ccr2.entities.customer_contacts ? ccr2.entities.customer_contacts[0].id : customer_contact_id;

              return CustomerContact.api().export(customer_contact_id).then(() => {
                customer_contact = CustomerContact.query().where('id', customer_contact_id).with(['contact','location','user']).first();
                return customer_contact;
              });
            
            });
    
        });
        
    });
    
  }

}